import { API_URL } from '../dataStore/api'

/**
 * URL namespace сокета админских заказов (Socket.io).
 * @returns полный URL для подключения к `/admin-orders`
 */
export const getAdminSocketUrl = (): string => `${API_URL}/admin-orders`
